import { render, staticRenderFns } from "./contentArchiveCatalog.vue?vue&type=template&id=7cf1326a&scoped=true&"
import script from "./contentArchiveCatalog.vue?vue&type=script&lang=js&"
export * from "./contentArchiveCatalog.vue?vue&type=script&lang=js&"
import style0 from "./contentArchiveCatalog.vue?vue&type=style&index=0&id=7cf1326a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf1326a",
  null
  
)

export default component.exports